import { Trans, useTranslation } from 'react-i18next';
import { Check } from '@mui/icons-material';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';

const welcomePermissionKeys = ['inviteUsers', 'managePermissions', 'manageCompany'] as const;

export function UserListWelcomeCard() {
  const { t } = useTranslation();

  return (
    <Card variant="outlined" sx={{ borderColor: 'success.main', mx: 0.5, mb: 10 }}>
      <CardContent sx={{ p: 1, '&:last-child': { pb: 1 } }}>
        <Stack spacing={2}>
          <Stack alignItems="center" spacing={0.5} color="success.main">
            <Typography variant="h5" component="h3" fontWeight={600}>
              {t('userAccessControl.welcome.title')}
            </Typography>
            <Check fontSize="large" aria-hidden="true" />
          </Stack>
          <Typography variant="body2" component="p" m={0}>
            <Box component="strong" display="block">
              {t('userAccessControl.welcome.registrationSuccessful')}
            </Box>
            {t('userAccessControl.welcome.registrationDescription')}
          </Typography>
          <Box>
            <Typography variant="body2" component="p" m={0}>
              {t('userAccessControl.welcome.asAdmin')}
            </Typography>
            <Box component="ul" sx={{ my: 0.5, pl: 3 }}>
              {welcomePermissionKeys.map((permission) => (
                <Typography component="li" variant="body2" key={permission}>
                  {t(`userAccessControl.welcome.permissions.${permission}`)}
                </Typography>
              ))}
            </Box>
          </Box>
          <Typography variant="body2" component="p" m={0}>
            <Trans
              i18nKey="userAccessControl.welcome.addFirstUser"
              components={{ action: <Box component="strong" sx={{ textTransform: 'uppercase' }} /> }}
            />
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
}
